module.exports = __webpack_public_path__ + "static/street-tacos-bbf3fbf63c76e51e081da5f165cd8e7e.jpg";